import { Link } from "react-router-dom";
import { PawPrint, Instagram, Twitter, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#2C3529] text-[#FAF9F6] mt-24"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-2.5 mb-5">
            <span className="grid place-items-center h-10 w-10 rounded-full bg-[#D96B43] text-white">
              <PawPrint size={20} strokeWidth={1.75} />
            </span>
            <span className="font-serif text-2xl font-semibold">PawJournal</span>
          </Link>
          <p className="font-sans text-[#c9ccc3] leading-relaxed max-w-sm">
            Thoughtful, warm, and honest pet care — written by people who
            genuinely love animals, for people who do too.
          </p>
          <div className="flex gap-3 mt-6">
            {[Instagram, Twitter, Facebook].map((Icon, i) => (
              <a
                key={i}
                href="#"
                data-testid={`social-link-${i}`}
                className="grid place-items-center h-10 w-10 rounded-full border border-white/20 hover:bg-[#D96B43] hover:border-[#D96B43] transition-colors duration-300"
              >
                <Icon size={18} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3 md:col-start-8">
          <h4 className="font-sans text-sm uppercase tracking-wider text-[#DDA77B] mb-5">
            Explore
          </h4>
          <ul className="space-y-3 font-sans text-[#c9ccc3]">
            <li><Link to="/blog" className="hover:text-white transition-colors">The Journal</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-sans text-sm uppercase tracking-wider text-[#DDA77B] mb-5">
            Topics
          </h4>
          <ul className="space-y-3 font-sans text-[#c9ccc3]">
            <li><Link to="/blog?category=dogs" className="hover:text-white transition-colors">Dogs</Link></li>
            <li><Link to="/blog?category=cats" className="hover:text-white transition-colors">Cats</Link></li>
            <li><Link to="/blog?category=birds" className="hover:text-white transition-colors">Birds</Link></li>
            <li><Link to="/blog?category=small-pets" className="hover:text-white transition-colors">Small Pets</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 text-sm text-[#8f978a] font-sans">
          © {new Date().getFullYear()} PawJournal. Made with care for animals everywhere.
        </div>
      </div>
    </footer>
  );
}
